<template>
    <div id="page-branch-list">
        <div class="vx-row">
            <div class="vx-col md:w-1/4 w-full " style="min-height:300px">
                <card-customer :data="customer" :isEdit="false"/>
            </div>
            <div class="vx-col md:w-3/4 w-full">
                <div class="vx-card p-6 w-full">
                    <div class="component vx-row">
                        <div class="vx-col w-full mt-4">
                            <label class="vs-input--label">{{ $t('cardCustomer.id') }} </label>
                            <span class="text-danger">*</span>
                            <vs-input :disabled="isUpdate" v-validate="'required|alpha_dash'" name="cardId" class="w-full" v-model="customer.cardNumber" :placeholder="$t('cardCustomer.id')"></vs-input>
                            <span class="text-danger text-sm">{{ errors.first('cardId') }}</span>
                        </div>

                        <div class="vx-col w-full mt-4" v-if="isUpdate">
                            <label class="vs-input--label" for="">{{ $t('cardCustomer.cardType') }} <span class="text-danger">*</span></label>
                            <v-select :disabled="isUpdate && customer.cardStatus === 1" v-validate="'required'" name="cardType" placeholder="Chọn loại thẻ sử dụng" v-model="cardTypeModel" :options="CardTypes"></v-select>
                            <span class="text-danger text-sm">{{ errors.first('cardType') }}</span>
                        </div>
                        <!-- <div class="vx-col w-full mt-4">
                            <label class="vs-input--label" for="">Chọn trạng thái sử dụng thẻ</label>
                            <v-select class="" placeholder="Chọn loại thẻ khách hàng" v-model="cardStatusModel" :options="CardStatus"></v-select>
                        </div> -->
                        <div class="vx-col w-full mt-4">
                            <label class="vs-input--label">{{ this.$t('cardCustomer.startDate') }} <span class="text-danger">*</span></label>
                            <datepicker :disabled="isUpdate" name="startDate" :placeholder="$t('cardCustomer.chooseStartDate')" :highlighted="highlighted" :disabledDates="disabledFn" :language="vi" :format="'dd/MM/yyyy'" v-model="customer.releaseDate"
                                        data-vv-validate-on="input" v-validate="'required'"
                                        ></datepicker>
                            <span class="text-danger text-sm">{{ errors.first('startDate') }}</span>
                        </div>
                    </div>
                    <div class="vx-row mt-4" v-if="employeeResponse && employeeResponse.isData">
                        <div class="vx-col w-full">
                            <label for="" class="font-bold">Thông tin</label>
                        </div>
                        <div class="vx-col md:w-1/3 w-full mt-2">
                            <vs-input class="w-full" :disabled="true" v-model="employeeResponse.fullName" label="Họ và tên"></vs-input>
                        </div>
                        <div class="vx-col md:w-1/3 w-full mt-2" v-if="employeeResponse.cardStaffType === 1">
                            <vs-input class="w-full" :disabled="true" v-model="employeeResponse.email" label="Email"></vs-input>
                        </div>
                        <div class="vx-col md:w-1/3 w-full mt-2" v-if="employeeResponse.cardStaffType === 1">
                            <vs-input class="w-full" :disabled="true" v-model="employeeResponse.birthday" label="Ngày sinh"></vs-input>
                        </div>
                        <div class="w-full vx-col mt-4">
                            <vs-input class="w-full" :disabled="true" v-model="employeeResponse.fullAddress" label="Địa chỉ"></vs-input>
                        </div>
                    </div>
                    <div class="vx-col w-full flex mt-6">
                        <vs-button class="ml-auto" type="border" @click="$router.go(-1)">{{ this.$t('cardCustomer.back') }}</vs-button>
                        <vs-button v-if="!isUpdate" :disabled="!validateForm" class="ml-4" @click="saveCardCustomer">{{ isUpdate ? this.$t('cardCustomer.update') : this.$t('cardCustomer.create') }}</vs-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import vSelect from 'vue-select';
import CardCustomer from "./card/CardCustomer.vue";
import Datepicker from 'vuejs-datepicker';
import {en, vi} from 'vuejs-datepicker/dist/locale'
import moment from 'moment';
export default {
    components: {
        vSelect,
        CardCustomer,
        Datepicker
    },
    computed: {
        validateForm() {
            return !this.errors.any()
        },
        cardTypeModel: {
            get(){
                let object = this.CardTypes.find(el => el.value == this.customer.cardStaffType);
                if (!object) return;
                return {
                    label: object.label,
                    value: object.value
                }
            },
            set(object){
                this.customer.cardStaffType = object ? object.value : null;
            }
        },
        cardStatusModel: {
            get(){
                let object = this.CardStatus.find(el => el.value == this.customer.cardStatus);
                if (!object) return;
                return {
                    label: object.label,
                    value: object.value
                }
            },
            set(object){
                this.customer.cardStatus = object ? object.value : null;
            }
        }
    },
    data(){
        return {
            employeeResponse: {},
            isUpdate: false,
            en: en,
            vi: vi,
            highlighted : {
                dates: [
                    new Date()
                ]
            },
            disabledFn: {
                customPredictor(date) {
                    if (moment(date).isBefore(moment(), 'days')) {
                        return true;
                    }
                }
            },
            customer: {
                cardStatus: 0,
                cardStaffType: 2
            },
            CardStatus: [
                {value: 0, label: this.$t('cardCustomer.using')},
                {value: 1, label: this.$t('cardCustomer.notUse')}
            ],
            CardTypes: [
                {value: 0, label: this.$t('cardCustomer.customer')},
                {value: 1, label: this.$t('cardCustomer.employee')},
                {value: 2, label: this.$t('cardCustomer.unknown')},
            ]
        }
    },
    methods: {
        async saveCardCustomer(){
            const result = await this.$validator.validateAll();
            if (!result) return;
            let path = this.isUpdate ? `/card-staff/update/${this.customer.cardNumber}` : '/card-staff/create';
            this.$crm.post(path, this.customer).then(() => {
                this.$router.push('/user/card-customer').catch(() => {});
                return this.$vs.notify({
                    color: 'success',
                    text: this.isUpdate ? this.$t('cardCustomer.updateCardCustomer') : this.$t('cardCustomer.createCardCustomer'),
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                });
            }).catch((err) => {
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            })
        },
        findById(cardId){
            this.$vs.loading();
            this.$crm.get(`/card-staff/find-by-id/${cardId}`).then((res) => {
                this.customer = res.data;
                let cardType = res.data.cardStaffType;
                this.isUpdate = true;
                if (cardType == 1) {
                    this.employeeResponse = res.data.employeeResponseDTO;
                    this.employeeResponse.cardStaffType = res.data.cardStaffType;
                    if (res.data.employeeResponseDTO) this.employeeResponse.isData = true;
                    this.customer.fullName = this.employeeResponse.fullName;
                    let birthday = new Date(this.employeeResponse.birthday);
                    this.employeeResponse.birthday = moment(birthday).format("DD/MM/YYYY");
                    if (this.employeeResponse.imageStore && this.employeeResponse.imageStore.length > 0) this.customer.urlImage = this.employeeResponse.imageStore[0].url;
                    this.customer.customerType = this.$t('menuCustomer.employee')
                }
                if (cardType  === 0) {
                    this.employeeResponse = res.data.customerResponseDTO;
                    this.employeeResponse.cardStaffType = res.data.cardStaffType;
                    this.customer.customerType = this.$t('menuCustomer.customer')
                    if (res.data.customerResponseDTO && this.employeeResponse.imageStore && this.employeeResponse.imageStore.length > 0) {
                        this.employeeResponse.isData = true;
                        this.customer.urlImage = this.employeeResponse.imageStore[0].url;
                    }
                }
                if (cardType === 2) {
                    this.customer.customerType = this.$t('menuCustomer.unknown')
                    this.employeeResponse.cardStaffType = res.data.cardStaffType;
                }
                this.$vs.loading.close();
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            })
        }
    },
    async created(){
        let query = this.$route.query;
        if (query.id) {
            this.findById(query.id);
        }
    }
}
</script>

<style >

</style>